"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var updateFavoritesUserOption_1 = require("./updateFavoritesUserOption");
var datapoints_1 = require("../datapoints");
var createDropViewState_1 = require("owa-dnd/lib/utils/createDropViewState");
var owa_mail_favorites_store_1 = require("owa-mail-favorites-store");
var legacy_1 = require("satcheljs/lib/legacy");
var isInFavorites_1 = require("../selectors/isInFavorites");
/**
 * Add a favorite search to the favorite store
 */
exports.default = legacy_1.action('AddFavoriteSearch', datapoints_1.default.AddFavoriteSearch)(function addFavoriteSearch(searchQuery, actionSource) {
    // Check if search query is already in favorites
    if (isInFavorites_1.isSearchInFavorites(searchQuery)) {
        throw new Error('Cannot add duplicate search query to favorites.');
    }
    // Add favorite to favorites store
    owa_mail_favorites_store_1.favoritesStore.orderedFavoritesNodeIds.push(searchQuery);
    owa_mail_favorites_store_1.favoritesStore.favoriteSearches.set(searchQuery, {
        id: searchQuery,
        type: 4 /* Search */,
        treeType: 'favorites',
        dropViewState: createDropViewState_1.default(),
    });
    // Update user options service which is used by OWA
    updateFavoritesUserOption_1.default();
});
//# sourceMappingURL=addFavoriteSearch.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/data/owa-mail-favorites-store/lib/actions/addFavoriteSearch.js
// module id = 6281
// module chunks = 68